/* -----------------Child components--------------- */

import { pageViewTypes } from "@constants/tracking";
import MoreRouteContainer from "@features/more/containers/MoreRouteContainer";
import useAnalytics from "@hooks/useAnalytics";
/* -----------------Types--------------- */
import DocumentTitle from "components/DocumentTitle";
import { useMemo } from "react";

const MoreRoute = () => {
	const memoizedAnalyticsParams = useMemo(() => {
		return {
			type: pageViewTypes.more,
		};
	}, []);
	useAnalytics(memoizedAnalyticsParams);
	return (
		<>
			<DocumentTitle title="More settings" />
			<MoreRouteContainer />
		</>
	);
};

export default MoreRoute;
